import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BCPTimer, BCPBars } from "../../../../components/icons/bcp/BCPIcons";

export default function TimerDisplaySelector(props) {
  const {
    displayMode,
    setDisplayMode,
    disabled = false,
    timerData,
    event,
    setRoundTimerOptions,
    onModalOpen
  } = props;
  const { t } = useTranslation("translation", {
    keyPrefix: "components.countdownTimer"
  });

  const options = [
    {
      mode: "timer",
      icon: <BCPTimer />,
      tooltip: t("displayModes.fullScreenTimer"),
      ariaLabel: "full-screen-timer"
    },
    {
      mode: "pairings",
      icon: <BCPBars />,
      tooltip: t("displayModes.fullScreenPairings"),
      ariaLabel: "full-screen-pairings"
    },
    {
      mode: "split",
      icon: (
        <i
          className="rmel-iconfont rmel-icon-view-split"
          style={{ fontSize: "28px" }}
        />
      ),
      tooltip: t("displayModes.splitScreen"),
      ariaLabel: "split-screen-timer-pairings"
    }
  ];

  const handleOptionClick = (mode) => {
    if (!timerData) {
      setRoundTimerOptions(event);
    } else {
      setDisplayMode(mode);
      if (onModalOpen) {
        onModalOpen();
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        p: 0.25,
        backgroundColor: "background.paper",
        mb: "8px",
        mt: "2px"
      }}
    >
      {options.map((option) => (
        <Tooltip key={option.mode} title={option.tooltip} arrow>
          <IconButton
            aria-label={option.ariaLabel}
            size="small"
            disabled={disabled}
            onClick={() => handleOptionClick(option.mode)}
            sx={{
              color:
                displayMode === option.mode ? "primary.main" : "text.secondary",
              backgroundColor:
                displayMode === option.mode ? "primary.light" : "transparent",
              "&:hover": {
                backgroundColor:
                  displayMode === option.mode ? "primary.light" : "action.hover"
              }
            }}
          >
            {option.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}
